/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareLiveAdmission } from './MatrixCareLiveAdmission';
import {
    MatrixCareLiveAdmissionFromJSON,
    MatrixCareLiveAdmissionFromJSONTyped,
    MatrixCareLiveAdmissionToJSON,
    MatrixCareLiveAdmissionToJSONTyped,
} from './MatrixCareLiveAdmission';

/**
 * 
 * @export
 * @interface FindAllMatrixCareHomeHealthCopySourcesResponse
 */
export interface FindAllMatrixCareHomeHealthCopySourcesResponse {
    /**
     * Admissions MatrixCare accepts as a copy source for a new admission. Often shorter than the patient's full history.
     * @type {Array<MatrixCareLiveAdmission>}
     * @memberof FindAllMatrixCareHomeHealthCopySourcesResponse
     */
    admissions: Array<MatrixCareLiveAdmission>;
}

/**
 * Check if a given object implements the FindAllMatrixCareHomeHealthCopySourcesResponse interface.
 */
export function instanceOfFindAllMatrixCareHomeHealthCopySourcesResponse(value: object): value is FindAllMatrixCareHomeHealthCopySourcesResponse {
    if (!('admissions' in value) || value['admissions'] === undefined) return false;
    return true;
}

export function FindAllMatrixCareHomeHealthCopySourcesResponseFromJSON(json: any): FindAllMatrixCareHomeHealthCopySourcesResponse {
    return FindAllMatrixCareHomeHealthCopySourcesResponseFromJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthCopySourcesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllMatrixCareHomeHealthCopySourcesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'admissions': ((json['admissions'] as Array<any>).map(MatrixCareLiveAdmissionFromJSON)),
    };
}

export function FindAllMatrixCareHomeHealthCopySourcesResponseToJSON(json: any): FindAllMatrixCareHomeHealthCopySourcesResponse {
    return FindAllMatrixCareHomeHealthCopySourcesResponseToJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthCopySourcesResponseToJSONTyped(value?: FindAllMatrixCareHomeHealthCopySourcesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admissions': ((value['admissions'] as Array<any>).map(MatrixCareLiveAdmissionToJSON)),
    };
}

